<template>
<div class="padre">
  <div class="container fondo">
    <img src="../assets/bg/inicio.jpg" alt="" class="bg">
    <img src="../assets/bg/inicio-celular.jpg" alt="" class="bgcel">
    <div class="contbut animate__animated animate__bounceIn animate__delay-1s">
    <RouterLink  v-bind:to = "'intro'" class="buprin buinicio">Empezar ></RouterLink>
    </div>
  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  mounted () {
    document.title = "Juego Cuido el Agua EPM"
  }
}
</script>

